import { actionWithDatapoint } from 'owa-analytics-actions';

import getEntryPoint from '../selectors/getEntryPoint';
import { getUserMailboxGuid } from '../utils/getMailboxGuid';

/**
 * Action to update the anonymous sharing flag.
 */

const setAnonymousSharingStatus = actionWithDatapoint(
    'setAnonymousSharingStatus',
    (isAnonymousSharingEnabled: boolean) => ({
        isAnonymousSharingEnabled,
    }),
    actionMessage => ({
        customData: {
            entryPoint: getEntryPoint(),
            isAnonymousSharingEnabled: actionMessage.isAnonymousSharingEnabled,
            mailboxGuid: getUserMailboxGuid(),
        },
    })
);

export default setAnonymousSharingStatus;
